import { useState } from "react";
import { Search } from "lucide-react";

export function SearchSuggest({ value, onChange, onPick, options, placeholder, testid }) {
  const [open, setOpen] = useState(false);
  const q = value.trim().toLowerCase();
  const sugs = open && q.length >= 1
    ? [...new Set(options)].filter((s) => s && s.toLowerCase().includes(q) && s.toLowerCase() !== q).slice(0, 7)
    : [];
  return (
    <div className="relative z-50 max-w-md">
      <Search size={15} className="absolute left-3 top-[19px] -translate-y-1/2 text-[#a855f7]" />
      <input value={value} data-testid={testid}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        className="w-full bg-[#121212] border border-white/15 focus:border-[#a855f7] rounded-lg pl-9 pr-3 py-2.5 text-sm text-white outline-none transition-colors duration-200" />
      {sugs.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-black border border-[#a855f7]/50 rounded-lg shadow-2xl shadow-black overflow-hidden" data-testid={`${testid}-suggestions`}>
          {sugs.map((s) => (
            <button key={s} onMouseDown={() => { (onPick || onChange)(s); setOpen(false); }}
              data-testid={`${testid}-suggestion-${s.replace(/[^a-zA-Z0-9]+/g, "-").toLowerCase()}`}
              className="flex items-center gap-2 w-full text-left px-3 py-2.5 text-sm font-semibold text-white hover:bg-[#a855f7]/15 hover:text-[#a855f7] border-b border-white/5 last:border-0 transition-colors duration-200">
              <Search size={12} className="text-[#a855f7] shrink-0" /> {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function HRLogChart({ log }) {
  if (!log?.games?.length) return <p className="text-xs text-neutral-500">No recent game data.</p>;
  return (
    <div>
      <div className="flex items-end gap-1 h-16" data-testid="hr-log-chart">
        {log.games.map((g, i) => (
          <div key={i} className="flex-1 flex flex-col items-center gap-0.5" title={`${g.date}: ${g.hr} HR, ${g.hits} H`}>
            <div className={`w-full rounded-t ${g.hr > 0 ? "bg-[#22c55e] green-glow" : g.hits > 0 ? "bg-[#a855f7]/50" : "bg-white/10"}`}
              style={{ height: `${g.hr > 0 ? 100 : g.hits > 0 ? 45 : 14}%` }} />
          </div>
        ))}
      </div>
      <div className="flex justify-between text-[9px] text-neutral-600 font-data mt-1">
        <span>{log.games[0]?.date?.slice(5)}</span><span>{log.games[log.games.length - 1]?.date?.slice(5)}</span>
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] mt-2">
        <span className={log.games_since_hr >= 7 ? "text-[#f59e0b] font-bold" : "text-neutral-400"}>
          {log.games_since_hr === 0 ? "Homered in his last game" : `${log.games_since_hr} games without a HR`}
        </span>
        <span className="text-neutral-400">L10: <b className="text-[#22c55e]">{log.hr_last10} HR</b></span>
        <span className="text-neutral-400">L15: <b className="text-[#22c55e]">{log.hr_last15} HR</b></span>
        <span className="text-neutral-600">green = HR game · gold = hit, no HR</span>
      </div>
    </div>
  );
}
